import * as types from './actionTypes';
import { getRequest, postRequest, putRequest, patchRequest, deleteRequest } from '../../lib/apiUtils';
import { TransactionTypes } from '../../lib/constants';
import { BigNumber } from 'bignumber.js';

export function getFunds() {
    return async (dispatch) => {
        dispatch({ type: types.START_GET_FUNDS });

        const response = await getRequest('/funds', null, []);

        dispatch({ type: types.GET_FUNDS, response });
    };
}

export function getFundsVerbose() {
    return async (dispatch) => {
        dispatch({ type: types.START_GET_FUNDS_VERBOSE });

        const response = await getRequest('/funds?verbose=true', null, []);

        dispatch({ type: types.GET_FUNDS_VERBOSE, response });
    };
}

export function createFund(fund) {
    return async (dispatch) => {
        dispatch({ type: types.START_CREATE_FUND });

        const response = await postRequest('/funds', fund);

        dispatch({ type: types.CREATE_FUND, response });

        if (response.success) {
            dispatch(getFunds());
            dispatch(getFundsVerbose());
        }
    };
}

export function getFundDetails(fundId) {
    return async (dispatch) => {
        dispatch({ type: types.START_GET_FUND_DETAILS });

        const response = await getRequest(`/funds/${fundId}`);

        dispatch({ type: types.GET_FUND_DETAILS, response });

    };
}

export function updateFundDetails(fundId, fund) {
    return async (dispatch) => {
        dispatch({ type: types.START_UPDATE_FUND });

        const response = await putRequest(`/funds/${fundId}`, fund, {});

        if (response.success) {
            dispatch(getFunds());
            const updatedFund = await getRequest(`/funds/${fundId}`);
            if(updatedFund.success) response.data = updatedFund.data;
        }

        dispatch({ type: types.UPDATE_FUND, response });

    };
}

function getUpdatedFundDetails(fundId) {
    return async dispatch => {
        const response = await getRequest(`/funds/${fundId}`);
        dispatch({ type: types.GET_FUND_DETAILS, response });
    }
}

export function clearFundDetails() {
    return async dispatch => {
        dispatch(clearReconciliationDetails());
        dispatch({ type: types.CLEAR_ACCOUNTING_TRANSACTIONS_TABLE_RECORDS });
        dispatch({ type: types.CLEAR_ACCOUNTING_OUTSIDE_TRANSACTIONS_TABLE_RECORDS });
    }
}


//all transactions:
export function getTransactions(fundId, page = 1, results = 12, sort = { by: 'date', direction: 'Descending' }) {
    return async (dispatch, getState) => {

        const settings = { page, results, sort };
        dispatch({ type: types.UPDATE_ACCOUNTING_TRANSACTIONS_TABLE, settings });

        const requestId = ++getState().accountingTransactionsTable.currentRequestId;
        dispatch({ type: types.START_GET_ACCOUNTING_TRANSACTIONS_TABLE_RECORDS, requestId });

        const tableSettings = getState().accountingTransactionsTable;
        const filterSettings = getState().fundDetails.transactionsFilters;

        let params = {
            page: tableSettings.page,
            sortBy: tableSettings.sort.by,
            sortDirection: tableSettings.sort.direction,
            results: tableSettings.resultsView,
            startDate: filterSettings.startDate,
            endDate: filterSettings.endDate,
            search: filterSettings.search,
            searchWithoutDate: !filterSettings.startDate && !filterSettings.endDate
        };

        const response = await getRequest(`/funds/${fundId}/transactions`, params);

        dispatch({ type: types.GET_ACCOUNTING_TRANSACTIONS_TABLE_RECORDS, ...{ response, requestId } });
    };
}

export function updateTransactionsFilters(fundId, update, getTrans, sort, results) {
    return dispatch => {
        dispatch({ type: types.UPDATE_ACCOUNTING_FILTERS, update });

        if(getTrans)
            dispatch(getTransactions(fundId, 1, results, sort));
    };
}

export function updateTransactionsTable(settings) {
    return dispatch => {
        dispatch({ type: types.UPDATE_ACCOUNTING_TRANSACTIONS_TABLE, settings });
    };
}

//outside transactions:
export function getOutsideTransactions(fundId, page = 1, results = 12, sort = { by: 'amount', direction: 'Descending' }) {
    return async (dispatch, getState) => {

        const settings = { page, results, sort };
        dispatch({ type: types.UPDATE_ACCOUNTING_OUTSIDE_TRANSACTIONS_TABLE, settings });

        const requestId = ++getState().accountingOutsideTransactionsTable.currentRequestId;
        dispatch({ type: types.START_GET_ACCOUNTING_OUTSIDE_TRANSACTIONS_TABLE_RECORDS, requestId });

        const tableSettings = getState().accountingOutsideTransactionsTable;
        const filterSettings = getState().fundDetails.outsideTransactionsFilters;

        let params = {
            page: tableSettings.page,
            sortBy: tableSettings.sort.by,
            sortDirection: tableSettings.sort.direction,
            results: tableSettings.resultsView,
            startDate: filterSettings.startDate,
            endDate: filterSettings.endDate,
            search: filterSettings.search,
            searchWithoutDate: !filterSettings.startDate && !filterSettings.endDate,
            sources: 'manual'
        };

        const response = await getRequest(`/funds/${fundId}/transactions`, params);

        dispatch({ type: types.GET_ACCOUNTING_OUTSIDE_TRANSACTIONS_TABLE_RECORDS, ...{ response, requestId } });
    };
}

export function updateOutsideTransactionsTable(settings) {
    return dispatch => {
        dispatch({ type: types.UPDATE_ACCOUNTING_OUTSIDE_TRANSACTIONS_TABLE, settings });
    };
}

export function updateOutsideTransactionsFilters(fundId, update, getTrans, sort, results) {
    return dispatch => {
        dispatch({ type: types.UPDATE_ACCOUNTING_OUTSIDE_TRANSACTION_FILTERS, update });

        if(getTrans)
            dispatch(getOutsideTransactions(fundId, 1, results, sort));
    };
}

export function createOutsideTransaction(fundId, transaction) {
    return async (dispatch) => {
        dispatch({ type: types.START_CREATE_OUTSIDE_TRANSACTION });

        const response = await postRequest(`/funds/${fundId}/transactions`, transaction);

        dispatch({ type: types.CREATE_OUTSIDE_TRANSACTION, response });

        if(response.success) dispatch(getUpdatedFundDetails(fundId));
    };
}

export function updateTransactionDetails(fundId, transactionId, transaction) {
    return async (dispatch) => {
        dispatch({ type: types.START_UPDATE_TRANSACTION });

        const response = await patchRequest(`/funds/${fundId}/${transactionId}`, transaction);

        dispatch({ type: types.UPDATE_TRANSACTION, response });

        if(response.success) dispatch(getUpdatedFundDetails(fundId));
    };
}

export function voidTransactions(fundId, transactionIds) {
    return async (dispatch) => {
        dispatch({ type: types.START_VOIDING_TRANSACTION });

        const response = await postRequest(`/funds/${fundId}/voidTransactions`, transactionIds);

        dispatch({ type: types.VOID_TRANSACTIONS, response });

        if(response.success) {
            dispatch(getUpdatedFundDetails(fundId));
            dispatch(getOutsideTransactions(fundId));
        }
    };
}

//reconciliation reports:
export function getReconciliationReports(fundId) {
    return async (dispatch, getState) => {
        dispatch({ type: types.START_GET_BANK_RECONCILIATIONS });

        const year = getState().reconciliationReports.filters.year;

        const response = await getRequest(`/funds/${fundId}/reconciliationReports`, { year });

        dispatch({ type: types.GET_BANK_RECONCILIATIONS, response });

        if(!year && response.success && response.data.years) {
            dispatch({ type: types.UPDATE_RECONCILIATION_REPORTS_FILTERS, filter: {year: response.data.years[0]} } );
        }
    };
}

export function updateReconciliationReportsFilters(filter, fundId) {
    return dispatch => {
        dispatch({ type: types.UPDATE_RECONCILIATION_REPORTS_FILTERS, filter});

        dispatch(getReconciliationReports(fundId));
    };
}

export function getReconciliationReport(fundId, reportId) {
    return async (dispatch, getState) => {
        dispatch({ type: types.START_GET_RECONCILIATION_REPORT });

        const response = await getRequest(`/funds/${fundId}/reconciliationReports/${reportId}`, { report: false });

        dispatch({ type: types.GET_RECONCILIATION_REPORT, response });
    };
}

export function createReconciliationReport(fundId, report, closeOnSave) {
    return async (dispatch) => {
        dispatch({ type: types.START_CREATE_RECONCILIATION_REPORT });

        const response = await postRequest(`/funds/${fundId}/reconciliationReports`, report);

        dispatch({ type: types.CREATE_RECONCILIATION_REPORT, response });
        if(response.success && !!closeOnSave) {
            dispatch(clearReconciliationDetails());
            dispatch(getReconciliationReports(fundId));
        }
    }
}

export function createAndCompleteReconciliationReport(fundId, report) {
    return async (dispatch) => {
        dispatch({ type: types.START_CREATE_AND_COMPLETE_RECONCILIATION_REPORT });

        const response = await postRequest(`/funds/${fundId}/reconciliationReports`, report);

        dispatch({ type: types.CREATE_AND_COMPLETE_RECONCILIATION_REPORT, response });
        if(response.success) {
            dispatch(clearReconciliationDetails());
            dispatch(getReconciliationReports(fundId));
        }
    }
}

export function updateReconciliationReport(fundId, reportId, transactions, adjustments, report, closeOnSave) {
    return async (dispatch) => {
        dispatch({ type: types.START_UPDATE_RECONCILIATION_REPORT });

        const response = await postRequest(`/funds/${fundId}/reconciliationReports/${reportId}/save`, 
        { 
            transactions, 
            adjustments,
            reportName: report.reportName,
            toDate: report.dateTo,
            statementBalance: report.statementBalance
        });

        dispatch({ type: types.UPDATE_RECONCILIATION_REPORT, response });
        if(response.success && !!closeOnSave) {
            dispatch(clearReconciliationDetails());
            dispatch(getReconciliationReports(fundId));
        }
    }
}

export function completeReconciliationReport(fundId, reportId, transactions, adjustments, report) {
    return async (dispatch) => {
        dispatch({ type: types.START_COMPLETE_RECONCILIATION_REPORT });

        const response = await postRequest(`/funds/${fundId}/reconciliationReports/${reportId}/reconcile`, 
        { 
            transactions, 
            adjustments,
            reportName: report.reportName,
            toDate: report.dateTo,
            statementBalance: report.statementBalance
        });

        dispatch({ type: types.COMPLETE_RECONCILIATION_REPORT, response });
        if(response.success) {
            dispatch(clearReconciliationDetails());
            dispatch(getReconciliationReports(fundId));
        }
    }
}

export function deleteReconciliationReport(fundId, reportId) {
    return async (dispatch) => {
        dispatch({ type: types.START_DELETE_RECONCILIATION_REPORT });

        const response = await deleteRequest(`/funds/${fundId}/reconciliationReports/${reportId}`);

        dispatch({ type: types.DELETE_RECONCILIATION_REPORT, response });
        if(response.success) {
            dispatch(clearReconciliationDetails());
            dispatch(getReconciliationReports(fundId));
        }
    }
}

export function calculateReconciliationBalance() {
    return (dispatch, getState) => {
        const selectedCredits = getState().reconciliationCreditsTable.selected;
        const selectedPayments = getState().reconciliationPaymentsTable.selected;
        const adjustmentCredits = getState().reconciliationReports.reconciliationAdjustments
            .filter((adj) => adj.transactionType === TransactionTypes.Deposit);
        const adjustmentPayments = getState().reconciliationReports.reconciliationAdjustments
            .filter((adj) => adj.transactionType === TransactionTypes.Withdrawal);

        const currentReconciliationBalance = getState().reconciliationReports.reconciliationReports.data.currentReconciliationBalance;
        const credits = [ ...selectedCredits, ...adjustmentCredits ]
            .reduce((total, trans) => total.plus(trans.amount), new BigNumber(0));
        const payments = [ ...selectedPayments, ...adjustmentPayments ]
            .reduce((total, trans) => total.plus(trans.amount), new BigNumber(0));

        let balance = new BigNumber(currentReconciliationBalance).plus(credits).minus(payments);

        dispatch({ type: types.UPDATE_RECONCILIATION_BALANCE, value: balance.toNumber() });
    }
}

export function clearReconciliationDetails() {
    return (dispatch, getState) => {
        dispatch({ type: types.CLEAR_RECONCILIATION_PAYMENTS_INFINITELIST_SELECTION });
        dispatch({ type: types.CLEAR_RECONCILIATION_CREDITS_INFINITELIST_SELECTION });
        dispatch({ type: types.CLEAR_RECONCILIATION_PAYMENTS_INFINITELIST_RECORDS });
        dispatch({ type: types.CLEAR_RECONCILIATION_CREDITS_INFINITELIST_RECORDS });
        dispatch({ type: types.UPDATE_RECONCILIATION_BALANCE, value: getState().reconciliationReports.reconciliationReports.data.currentReconciliationBalance });
        dispatch({ type: types.UPDATE_RECONCILIATION_ADJUSTMENTS, value: [] });
    };
}

export function getReconciliationPayments(fundId, startDate, endDate, reset = false, page = 1, results = 24, sort = { by: 'date', direction: 'Ascending' }) {
    return async (dispatch, getState) => {
        const configs = { page, results, sort };
        dispatch({ type: types.UPDATE_RECONCILIATION_PAYMENTS_INFINITELIST_CONFIGS, configs });
        
        const requestId = ++getState().reconciliationPaymentsTable.currentRequestId;
        dispatch({ type: types.START_GET_RECONCILIATION_PAYMENTS_INFINITELIST_RECORDS, requestId, reset: (reset || page === 1) });

        const tableSettings = getState().reconciliationPaymentsTable;

        let params = {
            page,
            results,
            sortBy: tableSettings.sort.by,
            sortDirection: tableSettings.sort.direction,
            startDate,
            endDate,
            statuses: 'outstanding',
            types: 'withdrawal',
            reconcile: true
        };

        const response = await getRequest(`/funds/${fundId}/transactions`, params);

        dispatch({ type: types.GET_RECONCILIATION_PAYMENTS_INFINITELIST_RECORDS, ...{ response, requestId } });
    };
}

export function toggleSelectReconciliationPayments(transaction) {
    return dispatch => {
        dispatch({ type: types.TOGGLE_SELECT_RECONCILIATION_PAYMENTS_INFINITELIST_RECORD, ...{ record: transaction, recordIdKey: 'transactionId' } });
        dispatch(calculateReconciliationBalance());
    };
}

export function getReconciliationCredits(fundId, startDate, endDate, reset = false, page = 1, results = 12, sort = { by: 'date', direction: 'Ascending' }) {
    return async (dispatch, getState) => {

        const configs = { page, results, sort };
        dispatch({ type: types.UPDATE_RECONCILIATION_CREDITS_INFINITELIST_CONFIGS, configs });

        const requestId = ++getState().reconciliationCreditsTable.currentRequestId;
        dispatch({ type: types.START_GET_RECONCILIATION_CREDITS_INFINITELIST_RECORDS, requestId, reset: (reset || page === 1) });

        const tableSettings = getState().reconciliationCreditsTable;

        let params = {
            page,
            results,
            sortBy: tableSettings.sort.by,
            sortDirection: tableSettings.sort.direction,
            startDate,
            endDate,
            statuses: 'outstanding',
            types: 'deposit',
            reconcile: true
        };

        const response = await getRequest(`/funds/${fundId}/transactions`, params);

        dispatch({ type: types.GET_RECONCILIATION_CREDITS_INFINITELIST_RECORDS, ...{ response, requestId } });
    };
}

export function toggleSelectReconciliationCredits(transaction) {
    return dispatch => {
        dispatch({ type: types.TOGGLE_SELECT_RECONCILIATION_CREDITS_INFINITELIST_RECORD, ...{ record: transaction, recordIdKey: 'transactionId' } });
        dispatch(calculateReconciliationBalance());
    }
}

export function updateReconciliationAdjustments(adjustments) {
    return dispatch => {
        dispatch({ type: types.UPDATE_RECONCILIATION_ADJUSTMENTS, value: (adjustments || []) });
        dispatch(calculateReconciliationBalance());
    };
}

export function getBlankChecks(fundId) {
    return async dispatch => {
        dispatch({ type: types.START_GET_BLANK_CHECKS });

        const response = await getRequest(`/funds/${fundId}/blankChecks`);

        dispatch({ type: types.GET_BLANK_CHECKS, response });
    }
}

export function clearManualChecks() {
    return async dispatch => {
        dispatch({ type: types.CLEAR_BLANK_CHECKS });
    }
}



// WEBPACK FOOTER //
// ./src/redux/actions/FundsActions.js